import { fetchStaticBlock, fetchHomepageBlocks, fetchPeriods } from '../../api'
import { user } from '@/api/endpoints'
import {eraseCookie, getCookie, setCookie} from "../../util/cookies";

const changeLanguage = ({ commit, state }, lang) => {
  commit('LANGUAGE_CHANGED', lang)
}

const loadingPageStart = ({ commit }) => {
  commit('LOADING_PAGE_START')
}

const loadingPageEnd = ({ commit }) => {
  commit('LOADING_PAGE_END')
}

const setDesktopDevice = ({ commit }) => {
  commit('DESKTOP_DEVICE_SET')
}

const setMobileDevice = ({ commit }) => {
  commit('MOBILE_DEVICE_SET')
}

const savingForm = ({ commit }, onGoing) => {
  commit('SAVING_FORM', onGoing)
}

const getStaticBlock = ({ commit }, staticBlockCode) => {
  return new Promise((resolve, reject) => {
    commit('CMS_BLOCK_LOADING')

    fetchStaticBlock(staticBlockCode)
      .then((response) => {
        if (response.success) {
          commit('CMS_BLOCK_UPDATED', response.data)
        } else {
          commit('CMS_BLOCK_ERROR')
        }

        resolve({
          success: response.success
        })
      })
      .catch((error) => {
        commit('CMS_BLOCK_ERROR')
        resolve({
          success: false
        })
      })
  })
}

const getHomepageBlocks = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('HOMEPAGE_BLOCKS_LOADING')

    fetchHomepageBlocks()
      .then((response) => {
        if (response.success) {
          commit('HOMEPAGE_BLOCKS_UPDATED', response.data)
        } else {
          commit('HOMEPAGE_BLOCKS_ERROR')
        }

        resolve({
          success: response.success
        })
      })
      .catch((error) => {
        console.error(error)
        commit('HOMEPAGE_BLOCKS_ERROR')
        resolve({
          success: false
        })
      })
  })
}

const getPeriods = ({ commit }, { reverse }) => {
  var params = {
    reverse
  }
  return new Promise((resolve, reject) => {
    commit('PERIOD_LOADING')

    fetchPeriods({ params })
      .then((response) => {
        if (response.success) {
          commit('PERIOD_UPDATED', response.data)
        } else {
          commit('PERIOD_ERROR')
        }

        resolve({
          success: response.success
        })
      })
      .catch((error) => {
        console.error(error)
        commit('PERIOD_ERROR')
        resolve({
          success: false
        })
      })
  })
}

const goToJumiaCentralAuth = () => {
  user.authUrl().then(res => {
    if (res.data.sso === "1" || getCookie("trigger-login")) {
      setCookie('auth-state', res.data.state, 1)
      eraseCookie("trigger-login")
      window.location.href = res.data.url
    }
  })
}

const signOut = () => {
  user.logoutUrl().then(res => {
    eraseCookie("redirect-url")
    eraseCookie("locale")
    eraseCookie("impersonate")
    window.location.href = res.data.url
  })
}

const setPageConfigs = ({ commit }, configs) => {
  commit('PAGE_CONFIGURATION', configs)
}

const setPageDialog = ({ commit }, dialog) => {
  commit('SET_PAGE_DIALOG', dialog)
}


const setToolbarButton = ({ commit }, value) => {
  commit('SET_TOOLBAR_BUTTON', value)
}

const setPageToolbarTitle = ({ commit }, title) => {
  commit('SET_PAGE_TOOLBAR_TITLE', title)
}

const setPageToolbarSubtitle = ({ commit }, subtitle) => {
  commit('SET_PAGE_TOOLBAR_SUBTITLE', subtitle)
}

const setPageToolbarDropdownList = ({ commit }, list) => {
  commit('SET_PAGE_TOOLBAR_DROPDOWN_LIST', list)
}

const setPageToolbarDropdownSelectedItem = ({ commit }, item) => {
  commit('SET_PAGE_TOOLBAR_DROPDOWN_SELECTED_ITEM', item)
}

export default {
  loadingPageStart,
  loadingPageEnd,
  changeLanguage,
  setDesktopDevice,
  setMobileDevice,
  savingForm,
  getStaticBlock,
  getHomepageBlocks,
  signOut,
  goToJumiaCentralAuth,
  setPageToolbarTitle,
  setPageToolbarSubtitle,
  setPageToolbarDropdownList,
  setPageToolbarDropdownSelectedItem,
  setPageConfigs,
  setPageDialog,
  getPeriods,
  setToolbarButton
}
